<template>
  <div class="app_activity">
    <drawer />
    <chatbox class="app_activity_chatbox"/>
  </div>
</template>

<script>
import Drawer from "./fragments/app.activity.drawer.fragment.vue";
import Chatbox from "./fragments/app.activity.chatbox.fragment.vue";

export default {
  name: "AppActivity",
  components: {
    Drawer,
    Chatbox,
  },
};
</script>

<style scoped>
.app_activity {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100vw;
}
.app_activity_chatbox{
  width: calc(100% - 230px)
}
</style>
